import {Col, Row} from "@bezlimit/bezlimit-ui";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
import Sign from "./sign";
// components

export default observer(function VerificationPage3() {
    return (
        <>
            <Row justify="center" gutter={32}>
                <Col lg={{span: 24}} xs={{span: 24}}>
                    <Sign />
                </Col>
            </Row>
        </>
    );
});
